import React from 'react';
import GameRoomPlayer from './GameRoomPlayer';
import { GameRoomPlayersInterface } from './GameRoomPlayersInterface';
import { getScore } from '../utils/ScoresUtils';

function GameRoomOnePlayer({players, currentRound, roundBlackCards, roundPhase, scoresMap, shouldShowHand}: GameRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="onePlayerPlayerWrapper">
                <GameRoomPlayer player={players[0]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[0].id)} shouldShowHand={shouldShowHand} />
            </div>
        </div>
    );
};

export default GameRoomOnePlayer;